<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @page-break="$emit('page-break')"
      @duplicate="$emit('duplicate')"
    />
    <div class="submit-wrapper" :style="wrapperStyle">
      <div id="turnstile-widget" />
    </div>
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";
import { set } from "lodash-es";
import { addScriptToPage } from "@/helpers/utils";

export default {
  name: "Recaptcha",
  components: {
    ElementControls,
  },
  mixins: [commonStyles],
  props: {
    item: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "verified"],
  computed: {
    sitekey() {
      switch (process.env.NODE_ENV) {
        case "production":
          return "0x4AAAAAAAL9h6n1Smj-qkHO";
        default:
          return "0x4AAAAAAAL_Vi9bJw77gB_K";
      }
    },
    wrapperStyle() {
      return {
        "justify-content": this.itemStyling.alignment || "left",
      };
    },
  },
  mounted() {
    // inject recaptcha script
    addScriptToPage(
      "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback",
    );
    window.onloadTurnstileCallback = () => this.render();
  },
  methods: {
    render() {
      turnstile.render("#turnstile-widget", {
        sitekey: this.sitekey,
        theme: "light",
        callback: (token) => {
          if (!this.editing) {
            set(this.item, "value", token);
            this.$emit("verified");
          }
        },
        "error-callback": (errorCode) => {
          console.log(`[Cloudflare Turnstile] Error: ${errorCode}`);
        },
      });
    },
  },
};
</script>
